import { AxiosError } from 'axios'

export default function isUniqueConstraintError(err: AxiosError) {
  const errorCode = err.response && err.response.data && err.response.data.error && err.response.data.error.code

  return errorCode && errorCode === 'UNIQUE'
}
